<template>
  <div>
    <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 10 }" :maxlength="200" v-model="remark" placeholder="请输入200字以内的用户备注" style="width:100%;"/>
    <div class="dialog-footer" style="text-align: center;margin-top: 16px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { updateQrCodeImgRemark } from "@/api/url";

export default {
  name: "LetterUpdateDialog",
  props: {
    value: Object
  },
  data() {
    return {
      remark: this.value.remark,
      id: this.value.id,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      this.loading = true
      let param = {};
      // param['id'] = this.imgForm.id?this.imgForm.id:0;
      param['id'] = this.id;
      param['remark'] = this.remark;
      postFormData(updateQrCodeImgRemark, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
